import { render, staticRenderFns } from "./VanFieldAcb.vue?vue&type=template&id=45ec5f40"
import script from "./VanFieldAcb.vue?vue&type=script&lang=js"
export * from "./VanFieldAcb.vue?vue&type=script&lang=js"
import style0 from "./VanFieldAcb.vue?vue&type=style&index=0&id=45ec5f40&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports